import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';

import { InputAdornment } from '@mui/material';
import { RealestateSizeTextField } from '../atomic-components/RealestateSizeTextField';
import { BuildingConditionSelector } from '../atomic-components/BuildingConditionSelector';
import { AssetFeatureSelector } from '../atomic-components/AssetFeatureSelector';
import { PropertyHighlightTextField } from '../atomic-components/PropertyHighlightTextField';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';
import { NumberOfRoomsTextField } from '../atomic-components/NumberOfRoomsTextField';
import { ExpectedBuildingStartDatePicker } from '../atomic-components/ExpectedBuildingStartDatePicker';
import { HighlightsList } from '../atomic-components/HighlightsList';

interface Props {
  disabled: boolean;
}

export const AssetPropertyOverview: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.main.propertyoverview.title')}>
      <AssetTypeConditional supported={['realEstate', 'powerplant', 'powerplantPortfolio', 'citizenParticipationLoan']}>
        <NumberOfRoomsTextField disabled={disabled} />
      </AssetTypeConditional>
      <AssetTypeConditional supported={['builderOwnerModel']}>
        <ExpectedBuildingStartDatePicker disabled={disabled} />
      </AssetTypeConditional>
      <PropertyHighlightTextField />
      <RealestateSizeTextField disabled={disabled} />
      <BuildingConditionSelector disabled={disabled} />
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.propertyoverview.fields.expertRating.label')}
        fieldName="investmentDetails.expertRating"
        type="number"
        endAdornment={<InputAdornment position="end">/5</InputAdornment>}
        inputProps={{ min: 0, max: 5, step: 0.1 }}
      />
      <DefaultFastTextField
        disabled={disabled}
        label={t('dashboard.assets.addedit.main.propertyoverview.fields.appraisalFirm.label')}
        fieldName="investmentDetails.appraisalFirm"
      />
      <AssetFeatureSelector disabled={disabled} />
      <HighlightsList disabled={disabled} />
    </LaunchpadCard>
  );
};
